import { QueryFunctionContext, useQuery } from '@tanstack/react-query';
import axios from 'axios';
import {
  ShipmentOrderSummaryByShipperResponse,
  ShipmentOrderSummaryByShipperResponseItem,
} from 'src/entities/ShipmentOrderSummaryByShipper.entity';

export const SHIPMENT_ORDERS_SUMMARY_BY_SHIPPER_QUERY_KEY = 'shipment-orders-summary-by-shipper';

export type UseShipmentOrdersSummaryByShipperParams = {
  startOn?: string;
  endOn?: string;
  enabled?: boolean;
};

type ShipmentOrdersSummaryByShipperQueryKey = [
  typeof SHIPMENT_ORDERS_SUMMARY_BY_SHIPPER_QUERY_KEY,
  {
    startOn?: string;
    endOn?: string;
  }
];

// 荷主別集計APIへGETリクエストを投げてダイアログ表示用のサマリーデータを取得する
const fetchShipmentOrdersSummaryByShipper = async (
  context: QueryFunctionContext<ShipmentOrdersSummaryByShipperQueryKey>,
) => {
  const [, params] = context.queryKey;
  const searchParams = new URLSearchParams();
  if (params.startOn) searchParams.set('start_on', params.startOn);
  if (params.endOn) searchParams.set('end_on', params.endOn);

  const queryString = searchParams.toString();
  const requestUrl = queryString.length > 0
    ? `/api/v5/shipment_orders/summary_by_shipper?${queryString}`
    : '/api/v5/shipment_orders/summary_by_shipper';

  const { data } = await axios.get<ShipmentOrderSummaryByShipperResponse>(requestUrl);
  return data.data;
};

// 画面のフィルタ条件に応じた荷主別集計データを取得するReact Queryフック
export const useQueryShipmentOrdersSummaryByShipper = ({
  startOn,
  endOn,
  enabled = true,
}: UseShipmentOrdersSummaryByShipperParams) => (
  useQuery<ShipmentOrderSummaryByShipperResponseItem[], Error>({
    queryKey: [
      SHIPMENT_ORDERS_SUMMARY_BY_SHIPPER_QUERY_KEY,
      { startOn, endOn },
    ],
    queryFn: fetchShipmentOrdersSummaryByShipper,
    enabled,
    refetchOnWindowFocus: false,
  })
);
